<!-- 투약현황 -->
<template>
  <div class="print-container">
    <div class="flex items-center justify-between mb-5">
      <h5 class="flex items-center"><i class="dot"></i>투약현황</h5>
      <div v-if="!readonly && !isPrint" class="flex items-center gap-4">
        <vs-button color="secondary" type="border" @click="handleAddRow"> 항목추가 </vs-button>
        <vs-button color="secondary" @click="handleRemoveRow"> 선택삭제 </vs-button>
      </div>
    </div>
    <table>
      <colgroup>
        <col v-if="!readonly && !isPrint" width="36" />
        <col />
        <col width="200" />
        <col width="240" />
        <col width="100" />
        <col width="100" />
        <col width="100" />
        <col width="100" />
      </colgroup>
      <thead>
        <th v-if="!readonly && !isPrint">
          <vs-checkbox :value="checkData.length === list.length && 0 < list.length" @click.native="onClickAllCheckbox" class="checkbox" />
        </th>
        <th>증상</th>
        <th>처방일</th>
        <th>약품명</th>
        <th>1회 복용량</th>
        <th>회수</th>
        <th>일수</th>
        <th>총량</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in list" :key="item.id">
          <td v-if="!readonly && !isPrint" class="align-middle p-0">
            <vs-checkbox :vs-value="item.id" v-model="checkData" class="checkbox" />
          </td>
          <td>
            <p v-if="isPrint" class="print-textarea">{{ item.input_1 }}</p>
            <ml-textarea v-else v-model="item.input_1" :readonly="readonly" class="w-full mb-0" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_2 }}</p>
            <date-selector v-else v-model="item.input_2" :readonly="readonly" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_3 }}</p>
            <ml-input v-else v-model="item.input_3" :readonly="readonly" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_4 }}</p>
            <vs-select v-else v-model="item.input_4" autocomplete :readonly="readonly" :disabled="readonly" class="w-full" @change="onChangeTotal(index, item)">
              <vs-select-item v-for="option in [1, 2, 3]" :key="option" :text="option" :value="option" />
            </vs-select>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_5 }}</p>
            <vs-select v-else v-model="item.input_5" autocomplete :readonly="readonly" :disabled="readonly" class="w-full" @change="onChangeTotal(index, item)">
              <vs-select-item v-for="option in [1, 2, 3]" :key="option" :text="option" :value="option" />
            </vs-select>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_6 }}</p>
            <vs-select v-else v-model="item.input_6" autocomplete :readonly="readonly" :disabled="readonly" class="w-full" @change="onChangeTotal(index, item)">
              <vs-select-item v-for="option in [1, 2, 3]" :key="option" :text="option" :value="option" />
            </vs-select>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ item.input_7 }}</p>
            <ml-input v-else v-model="item.input_7" readonly class="w-full" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
export default {
  components: {
    DateSelector,
  },
  props: {
    value: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkData: [],
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,
      list: this.value,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    // 항목추가
    handleAddRow() {
      const addData = { id: ++this.numberId };
      this.list.push(addData);
    },
    // 선택삭제
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];
    },
    // All 체크박스 클릭
    onClickAllCheckbox() {
      if (this.checkData.length === this.list.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    onChangeTotal(index, item) {
      if (!!item.input_4 && !!item.input_5 && !!item.input_6) this.$set(this.list[index], "input_7", item.input_4 * item.input_5 * item.input_6);
      else this.$set(this.list[index], "input_7", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox::v-deep {
  justify-content: center !important;
  span {
    margin: 0px !important;
  }
}
.content-container {
  display: flex;

  &:nth-child(n + 3) {
    .checkbox-container {
      border-top: 0px;
    }
    table:first-child {
      tr:first-child th {
        border-top: 0px;
      }
    }
  }

  table:nth-child(n + 2) {
    margin-top: -1px;
  }
}

.checkbox-container {
  width: 36px;

  display: flex;
  justify-content: center;

  background: #f9f9f9;
  border: 1px solid #cdcdcd;
  border-right: 0px;
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    background: #f9f9f9;
    padding: 18px 0px;
  }

  td {
    vertical-align: top;
    padding: 7px;
  }
}
</style>
